import { goURL } from '../../../../webmodule-common/other/ui/resource-resolver';
export const resourceClient = 'Client';
export async function launchClient(id: string): Promise<boolean> {
  goURL(resourceClient, id);
  return true;
}
